import { Injectable } from '@angular/core';


export class ScoreCardGroupScoreAnalysis {
  Id: number;
  ScoreCardGroup: string;
  WeightGuage: number;
  Rating: string;
  Score: number;
  WeightedScore: number;
  Formula: string;
  WeightedScoreDummy: number;
}

export class FinancialIndexWithScore {
  Index: string;
  Score: number;
}

export class FinancialIndexWithRating {
  Index: string;
  Rating: string;
}

export class APIParamSA {
  ScoreCardGroupScoreAnalysis: ScoreCardGroupScoreAnalysis[];
  WeightedScore: number;
  QualitativeWeightedScore: string;
  FinancialIndexWithScore: FinancialIndexWithScore[];
  FinancialIndexWithRating: FinancialIndexWithRating[];
  FAScoringModelFinalScoreView: any[];
  sParam: string;
}

export class QualitativeWeightedScoreResponse {
  Score: number;
  Rating: string;
}
